import { render, staticRenderFns } from "./ProjectTable.vue?vue&type=template&id=3de5f45e&scoped=true"
import script from "./ProjectTable.vue?vue&type=script&lang=js"
export * from "./ProjectTable.vue?vue&type=script&lang=js"
import style0 from "./ProjectTable.vue?vue&type=style&index=0&id=3de5f45e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de5f45e",
  null
  
)

export default component.exports